import { setLanguage, setAuth } from "actions";
import { configureStore } from "configureStore";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { browserHistory, Router } from "react-router";
import { syncHistoryWithStore } from "react-router-redux";
import { getRoutes } from "routes";
import {
  getLocalStorageAuth,
  setLocalStorageAuth,
  setCreditNoteRedirectStorage,
  setSubscriptionsRedirectStorage
} from "PaymentAPI";
import {
  setAuthUser,
  fetchOrders,
  fetchOrderLines,
  loginWithToken
} from "thunks";
import { getCookie, getUrlParams, getAuthInfos } from "utils";
import {
  APP_ENV,
  TTP_API_URL,
  TTP_HOME_URL,
  TTP_PAYMENT_URL,
  AUTH_LOW_SECURITY_COOKIE_NAME
} from "Config";
import { setEmbedded } from "actions";
import { initSentry } from "./sentry";

// App css
import "applicationStyles";
import AdyenEncrypt from "adyen-encrypt/dist/index";
// Load foundation JS
import "foundation-sites/dist/js/plugins/foundation.core";
import "foundation-sites/dist/js/plugins/foundation.util.keyboard.js";
import "foundation-sites/dist/js/plugins/foundation.util.triggers.js";
import "foundation-sites/dist/js/plugins/foundation.util.mediaQuery.js";
import "foundation-sites/dist/js/plugins/foundation.util.motion.js";
import "foundation-sites/dist/js/plugins/foundation.reveal.js";
import "foundation-sites/dist/js/plugins/foundation.offcanvas.js";
import "foundation-sites/dist/js/plugins/foundation.util.box.js";
import "foundation-sites/dist/js/plugins/foundation.util.nest.js";
import "foundation-sites/dist/js/plugins/foundation.dropdownMenu.js";
import "foundation-sites/dist/js/plugins/foundation.tooltip";
$(document).foundation();
// Configure Store
const store = configureStore();

// Init Sentry
initSentry(store, {
  APP_ENV,
  APP_NAME: "payment",
  APP_RELEASE: "2.0.0",
  APP_SENTRY_KEY: "e40706a3be334041b98dda127aeb8dec",
  APP_SENTRY_ID: "10"
});

const now = Math.floor(new Date().getTime() / 1000);
const userCookie = getCookie("ttp_auth_" + APP_ENV);
let stringUrl = window.location.href;
let url = new URL(stringUrl);
let token = url.searchParams.get("token");

if (token && token !== "") {
  store.dispatch(loginWithToken(token));
} else {
  const hsAuthInfos = getAuthInfos("ttp_auth_" + APP_ENV);
  const lsAuthInfos = getAuthInfos(AUTH_LOW_SECURITY_COOKIE_NAME);

  const { authInfos, expired } =
    hsAuthInfos.expired && !lsAuthInfos.expired ? lsAuthInfos : hsAuthInfos;

  if (authInfos && !expired) {
    const auth = getLocalStorageAuth();
    if (auth && auth.user != null && authInfos.token === auth.token) {
      store.dispatch(setAuth(auth));
    } else {
      store.dispatch(setAuthUser(authInfos)).then(res => {
        const { language, paymentClients } = res.value;
        store.dispatch(setLanguage(language || "fr"));
        const selectedClients = paymentClients.filter(
          ({ isSelected }) => isSelected
        );
        if (!selectedClients || selectedClients.length === 0) {
          return;
        }
      });
    }
  } else {
    let url = new URL(window.location.href);
    let connectionAllowed = url.searchParams.get("connectionAllowed");
    
    if (
      location.href.indexOf("userCreditNote") != -1 ||
      location.href.indexOf("subscriptions") != -1
    ) {
      // const params = getUrlParams();
      
      if (
        location.href.indexOf("userCreditNote") != -1 &&
        params.creditNoteId
      ) {
        const goto = location.toString();

        setCreditNoteRedirectStorage(location.toString());
        window.location.replace(TTP_HOME_URL + "?goto=" + goto);
      }
      if (
        location.href.indexOf("subscriptions") != -1 &&
        connectionAllowed &&
        connectionAllowed == 1
      ) {
        const goto = location.toString();
        
        setSubscriptionsRedirectStorage(location.toString());
        window.location.replace(TTP_HOME_URL + "?goto=" + goto);
      }
    }

    if (
      location.href.indexOf("assignments") != -1 &&
      connectionAllowed &&
      connectionAllowed == 1
    ) {
      const goto = location.toString();
      window.location.replace(TTP_HOME_URL + "?goto=" + goto);
    }

    if (
      location.href.indexOf("documentDetail") !== -1 &&
      connectionAllowed &&
      connectionAllowed == 1
    ) {
      const goto = location.toString();
      window.location.replace(TTP_HOME_URL + "?goto=" + goto);
    }
    

    setLocalStorageAuth(null);
  }
}

let lng = null;
try {
  lng = localStorage.getItem("lng");
} catch (e) {}
if (!lng) {
  if (store.auth && store.auth.user != null) {
    lng = store.auth.user.language;
  } else {
    const navigatorLanguage = navigator.language || navigator.userLanguage;
    lng =
      ["fr", "en", "nl"].indexOf(navigatorLanguage) > -1
        ? navigatorLanguage
        : "fr";
  }
}
store.dispatch(setLanguage(lng));

if (typeof window !== "undefined") {
  try {
    if (
      window.location.pathname == "/paymentMethode"  ||
      window.location.pathname.includes("subscription/")
    ) {
      // tester si j'ai le params embedded qui est egale à true si oui je vais dispatcher une action pour le rendre true dans store
      if (
        getUrlParams() &&
        getUrlParams().embedded &&
        getUrlParams().embedded == 1
      ) {
        store.dispatch(setEmbedded(1));
      }
    }
  } catch (e) {}
}

const history = syncHistoryWithStore(browserHistory, store);

const root = createRoot(document.getElementById("app"));
root.render(
  <Provider store={store}>
    <Router history={history}>{getRoutes(store)}</Router>
  </Provider>
);



// WEBPACK FOOTER //
// ./app/app.js